export default __webpack_public_path__ + "static/media/Definix-advance-crypto-assets.4940d8d4.png";